import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Grid,
  Typography, Chip, Divider, Box, Button, Checkbox, FormControlLabel, Slide
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { putData } from "../../BaseUrl";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Field = ({ label, value }) => (
  <Box mb={1.5}>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <Typography variant="body2" fontWeight={500}>{value || "-"}</Typography>
  </Box>
);

const PaymentDetailDialog = ({ open, onClose, record, onSuccess }) => {
  const [verified, setVerified] = useState(record?.verified || record?.status === "verified" || false);
  const [loading, setLoading] = useState(false);

  if (!record) return null;

  const handleVerify = async () => {
    setLoading(true);
    try {
      await putData(`admin/payment/verify/${record.id}`, { verified: true });
      onSuccess("Payment verified successfully");
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth TransitionComponent={Transition}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box>
          <Typography variant="h6" fontWeight="bold">Payment Details</Typography>
          <Typography variant="body2" color="text.secondary">
            Payment ID: {record.paymentId || record.transactionId || record.id}
          </Typography>
        </Box>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* Payee Details */}
        <Typography variant="subtitle1" fontWeight="bold" color="#1a237e" gutterBottom>
          Payee Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={4}><Field label="Payee Name" value={record.payee || record.payeeName} /></Grid>
          <Grid item xs={4}><Field label="Email" value={record.payeeEmail || record.email} /></Grid>
          <Grid item xs={4}><Field label="Phone" value={record.payeePhone || record.phone} /></Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Student Details */}
        <Typography variant="subtitle1" fontWeight="bold" color="#1a237e" gutterBottom>
          Student Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={4}><Field label="Student Name" value={record.studentName || record.name} /></Grid>
          <Grid item xs={4}><Field label="Registration No" value={record.registrationNumber || record.regNo} /></Grid>
          <Grid item xs={4}><Field label="Grade" value={record.grade} /></Grid>
          <Grid item xs={4}><Field label="Section" value={record.section} /></Grid>
          <Grid item xs={4}><Field label="Parent Name" value={record.parentName} /></Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Payment Details */}
        <Typography variant="subtitle1" fontWeight="bold" color="#1a237e" gutterBottom>
          Payment Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={4}><Field label="Amount" value={record.amount ? `$${record.amount}` : "-"} /></Grid>
          <Grid item xs={4}><Field label="Payment Date" value={record.date || record.paymentDate} /></Grid>
          <Grid item xs={4}><Field label="Transaction ID" value={record.transactionId || record.zelleTransactionId} /></Grid>
          <Grid item xs={4}><Field label="Payment Method" value={record.paymentMethod || "Zelle"} /></Grid>
          <Grid item xs={4}>
            <Typography variant="caption" color="text.secondary">Status</Typography>
            <Box mt={0.5}>
              <Chip label={record.status ? record.status.charAt(0).toUpperCase() + record.status.slice(1) : "Pending"}
                size="small" sx={{
                  backgroundColor: record.status === "verified" || record.status === "paid" ? "#e8f5e9" : "#fff3e0",
                  color: record.status === "verified" || record.status === "paid" ? "#4caf50" : "#ff9800",
                  fontWeight: 600
                }} />
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Verification */}
        <Box sx={{ p: 2, borderRadius: 2, backgroundColor: "#f5f3ff" }}>
          <FormControlLabel
            control={
              <Checkbox checked={verified} onChange={(e) => setVerified(e.target.checked)}
                sx={{ color: "#244C77", "&.Mui-checked": { color: "#244C77" } }} />
            }
            label={
              <Typography variant="body2" fontWeight={500}>
                I confirm that this payment has been verified and received
              </Typography>
            }
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit"
          sx={{ textTransform: "none" }}>
          Close
        </Button>
        <Button onClick={handleVerify} variant="contained" disabled={loading || !verified}
          sx={{ background: "linear-gradient(90deg, #4A7BA8, #244C77)", textTransform: "none" }}>
          {loading ? "Verifying..." : "Verify Payment"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDetailDialog;
